import React from 'react';
import { Link } from 'react-router';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

class Home extends React.Component {
  constructor(props) {
    super(props);

    this.state = {

    };

    this.setBody(this.props.location.pathname);
  }

  componentDidMount() {

  }

  componentWillReceiveProps(nextProps) {
    this.setBody(nextProps.location.pathname);
  }

  setBody(pathname) {
    console.log("set path: " + pathname);
    if(pathname != "/" && pathname != "/about" && pathname != "about") {
      document.body.className = "";
    } else {
      document.body.className = " white";
    }
  }

  render() {

    var leftLink = <Link to="/about" activeClassName="active" className="menu-sub menu-left">About</Link>,
        rightLink = <Link to="/watch" activeClassName="active" className="menu-sub menu-right">Watch</Link>;

    if(this.props.location.pathname == "/" || this.props.location.pathname.indexOf("booth") != -1 || this.props.location.pathname.indexOf("thanks") != -1) {
      leftLink = null;
      rightLink = null;
    }
    if(this.props.location.pathname.indexOf("watch") != -1) {
      leftLink = <Link to="/about" activeClassName="active" className="menu-sub menu-left">About</Link>,
      rightLink = <Link to="/record" activeClassName="active" className="menu-sub menu-right">Dance</Link>;
    }

    if(this.props.location.pathname.indexOf("about") != -1) {
      leftLink = <Link to="/watch" activeClassName="active" className="menu-sub menu-left">Watch</Link>,
      rightLink = <Link to="/record" activeClassName="active" className="menu-sub menu-right">Dance</Link>;
    }
    return(
      <div className="full">
        <div className="menu">
          <Link to="/" activeClassName="active"><span>Dance</span><span>2</span><span>me</span></Link>
          <div className="minor">By <a href="http://www.carrdancemedia.com/" target="_blank">Bryon Carr</a> and <a href="http://khariskennedy.com/" target="_blank">Kharis Kennedy</a></div>
        </div>

        {leftLink}
        {rightLink}

        {this.props.children}

      </div>
    )
  }
}

export default Home;



// WEBPACK FOOTER //
// src/Container.js